var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"20","viewBox":"0 0 12 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1L10 10L1 19","stroke":"#666666","stroke-width":"2.5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }